import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { fetchCountryCode } from "../../utils/fetchCountryCode";
import { useCompanyStore } from "../../state/useCompanyStore";

interface PhoneInputComponentProps {
  placeholder?: string;
  initialPhoneNumber?: string;
  onPhoneNumberChange: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  inputClass?: string;
  containerClass?: string;
  value?: string;
  disableDropdown?: boolean;
  clearPhoneError?: () => void;
  countryISO2?: string;
  autoSetISO2?: boolean;
  isUser?: boolean; // checks if user number exits
}

const PhoneInputComponent: React.FC<PhoneInputComponentProps> = ({
  placeholder,
  initialPhoneNumber,
  onPhoneNumberChange,
  onKeyDown,
  disabled,
  inputClass,
  containerClass,
  value,
  disableDropdown,
  clearPhoneError,
  countryISO2,
  autoSetISO2 = true,
  isUser,
}) => {
  const companyISO2 = useCompanyStore().company.country;

  const [phoneNumber, setPhoneNumber] = useState(
    value || initialPhoneNumber || "",
  );

  const [userIso2, setUserIso2] = useState("");

  useEffect(() => {
    if (value) {
      setPhoneNumber(value);
    }
  }, [value]);

  useEffect(() => {
    if (!isUser) {
      const getCountryCode = async () => {
        if (companyISO2) {
          setUserIso2(companyISO2);
        } else if (autoSetISO2) {
          try {
            const data = await fetchCountryCode();
            setUserIso2(data.country_code);
          } catch (error) {
            setUserIso2("");
            console.error("Failed to fetch country code.");
          }
        } else {
          setUserIso2(countryISO2 || "");
        }
      };
      getCountryCode();
    }
  }, [autoSetISO2, countryISO2]);

  const handleChange = (value: string, data: any) => {
    clearPhoneError?.();
    let normalizedPhone = value;

    if (value.startsWith("+234") && data.dialCode !== "234") {
      normalizedPhone = `+${value.substring(4)}`;
    }
    setPhoneNumber(normalizedPhone);
  };

  return (
    <PhoneInput
      placeholder={placeholder}
      value={phoneNumber}
      onChange={handleChange}
      inputProps={{ required: true }}
      disabled={disabled}
      inputClass={inputClass}
      containerClass={containerClass}
      disableDropdown={disableDropdown}
      enableSearch={true}
      enableAreaCodes={false}
      countryCodeEditable={false}
      country={userIso2.toLowerCase()}
      onBlur={() => {
        onPhoneNumberChange(phoneNumber);
      }}
      onKeyDown={onKeyDown}
    />
  );
};

export default PhoneInputComponent;
